/*
 * Author: Dw
 * File Created: Friday, 24-08-23 02:01 pm
 * Last Modified: Friday, 24-08-23 04:58 pm, by Dw
 */

import { useCallback, useEffect } from 'react';

import { useRouter } from 'next/router';

import { logger } from '@/utils';

import useLanguage from './useLanguage';

const usePrefetch = (path: string[]) => {
  const { curLocale } = useLanguage();
  const router = useRouter();

  const prefetchPages = useCallback(async () => {
    for (const item of path) {
      try {
        // eslint-disable-next-line -- no-await-in-loop
        await router.prefetch(item, '', {
          locale: curLocale,
        });
      } catch (error) {
        logger.error(`Failed to prefetch ${item}:`, error);
      }
    }
  }, [curLocale, path, router]);

  useEffect(() => {
    void prefetchPages();
  }, [prefetchPages]); // 加入 prefetchPages 作为依赖项
};

export default usePrefetch;
